import { fetchLink, Link } from '@padlet/arvo'
import {
  BeethovenDisplayAttributes,
  BeethovenDisplayOptions,
  getDisplayAttributes as originalGetDisplayAttributes,
} from '@padlet/beethoven-client'
import { fetchJson } from '@padlet/fetch'
import environment from 'bits/environment'
import { captureMessage } from 'bits/error_tracker'
import window from 'bits/global'
import memoize from 'lodash.memoize'

let beethovenApiHost = 'https://assets.padletcdn.com'
if (environment === 'staging') {
  beethovenApiHost = 'https://padlet.io'
} else if (environment === 'development') {
  beethovenApiHost = window.location.origin
}

const memoizedArvoFetchLink = memoize(fetchLink)
const directFetchLink = (url: string): Promise<Link> => {
  const fetchUrl = `${beethovenApiHost}/static/v1/api/links?url=${encodeURIComponent(url)}`
  return fetchJson(fetchUrl)
}

const memoizedDirectFetchLink = memoize(directFetchLink)

async function getDisplayAttributes(
  url: string,
  options: BeethovenDisplayOptions & { useArvo: boolean },
): Promise<BeethovenDisplayAttributes | null> {
  const displayOptions = options as BeethovenDisplayOptions
  const useArvo = options.useArvo === false ? false : true // defaulting to useArvo=true if the option is not set
  let fetchLink = memoizedArvoFetchLink
  if (!useArvo) {
    fetchLink = memoizedDirectFetchLink
  }
  try {
    const link: Link | null = await fetchLink(url)
    if (!link) return null
    return originalGetDisplayAttributes(link, displayOptions)
  } catch (e) {
    const context = {
      error: e,
      vueStartingState: window.ww.vueStartingState,
    }
    captureMessage('Fail to fetch link', { context })
    return null
  }
}

export { getDisplayAttributes, originalGetDisplayAttributes }
